export const benchmarking = {
  state: {},
  reducers: { setStartTime: (state, { time, operationName }) => ({ [operationName]: time }) },
};
